import React from "react";

class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(/*error: any*/) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(/*error: any, errorInfo: any*/) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <div className="tw:!px-6 tw:!h-full tw:!mb-12 tw:!max-h-[70vh] tw:!overflow-y-auto">
          <p>Sorry, there was a problem. Please try your search again.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
